import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import useApi from "../api";
import { CustomError } from "../errors";
import { SearchRoleResponse } from "./type";

export const useRolesApi = () => {
  const api = useApi();

  const baseurl = "/roles";

  const useRoles = useCallback(() => {
    const result = useQuery<SearchRoleResponse, CustomError>({
      queryKey: [baseurl],
      queryFn: ({ signal }) => api.get<SearchRoleResponse>({ url: baseurl, signal }),
    });
    return { ...result, error: result.error ?? undefined };
  }, [api]);

  return { useRoles };
};
